module.exports = require('./lib/password-generator');